<ng-container *ngIf="!!get">
    <tt-card>
        <tt-tabs ttRememberId="w_orderhead.gb_orderhead_main_orderpicks_status" [(ttSelectedId)]="get.gb_orderhead_main_orderpicks_status" (ttSelectedIdChange)="onTabChanged()">
            <tt-tab ttId="NOT_ADDED" ttLabel="gb_orderhead_main_orderpicks_status_not_added"></tt-tab>
            <tt-tab ttId="ADDED" ttLabel="gb_orderhead_main_orderpicks_status_added"></tt-tab>
            <tt-tab ttId="COMPLETEDPICKS" ttLabel="gb_orderhead_main_orderpicks_status_completedpicks"></tt-tab>
        </tt-tabs>
    </tt-card>
    <tt-grid [hidden]="get.gb_orderhead_main_orderpicks_status !== 'NOT_ADDED'" *ngIf="!!orderPicksGrid" [(ttOptions)]="orderPicksGrid"></tt-grid>
    <tt-grid [hidden]="get.gb_orderhead_main_orderpicks_status !== 'ADDED'" *ngIf="!!orderPicksAddedGrid" [(ttOptions)]="orderPicksAddedGrid"></tt-grid>
    <tt-grid [hidden]="get.gb_orderhead_main_orderpicks_status !== 'COMPLETEDPICKS'" *ngIf="!!orderPicksCompletedGrid" [(ttOptions)]="orderPicksCompletedGrid"></tt-grid>
</ng-container>
